"use client"; import React from "react"; export function RAGManagerClient() { return <div className="p-6"><h2 className="text-xl font-bold">RAG 관리</h2><p className="text-gray-600">API 기반 RAG 엔진 관리</p></div>; }
